module.exports = __webpack_public_path__ + "img/avatar0.56304a67.png";